var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main-outfit-container" }, [
    _c(
      "div",
      {
        staticClass:
          "generated-outfit-container overflowHidden saved-outfit-container",
        attrs: { id: "generated-outfit-container" }
      },
      [
        _c(
          "transition",
          {
            attrs: {
              name: "fade",
              mode: "out-in",
              duration: { enter: 1100, leave: 800 }
            }
          },
          [
            _vm.outfitCurrent.products
              ? _c(
                  "div",
                  { key: "1", staticClass: "outfit-items-container" },
                  [
                    _c("outfit-card", {
                      attrs: {
                        outfit: _vm.outfitCurrent,
                        handleProductClk: _vm.handleItemClick
                      }
                    })
                  ],
                  1
                )
              : _c("div", { key: "2" }, [_c("loader")], 1)
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ed514dc", { render: render, staticRenderFns: staticRenderFns })
  }
}